<template>
  <base-dialog
    ref="dialog"
    title="権限をコピー"
    message="権限名を入力してください。"
    :loading="loading"
    cancel-text="キャンセル"
    submit-text="コピー"
    @submit="submit"
  >
    <template v-slot:card-content>
      <v-form ref="form" lazy-validation>
        <v-text-field
          v-model="name"
          placeholder="権限名"
          class="mb-4"
          :rules="[(v) => !!v || '必ず入力してください']"
          required
          dense
          outlined
          filled
        />
      </v-form>
    </template>
  </base-dialog>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      name: '',
    }
  },
  methods: {
    open(name) {
      this.loading = false
      this.name = name
      this.$refs.dialog.open()
    },
    close() {
      this.loading = false
      this.$refs.dialog.close()
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      this.$emit('submit', this.name)
    },
  },
}
</script>
